import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import MainTitle from "../components/Apply/MainTitle";
import Form from "../components/ApplyForm/Form";
import { useLocation } from "react-router-dom";
import useTranslation from "../hooks/useTranslation";

const useStyles = () => ({
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
});

const ApplyForm = () => {
  const classes = useStyles();
  const boxRef = useRef(null);
  const { pathname } = useLocation();
  const { title, subtitle, backgroundImg } = useTranslation(
    pathname,
    "ApplyForm"
  );

  useEffect(() => {
    if (boxRef.current) {
      boxRef.current.scrollIntoView();
    }
  }, []);

  return (
    <>
      <MainTitle
        title={title}
        subtitle={subtitle}
        img={backgroundImg}
        width={{ xs: "287px", md: "400px" }}
      />
      <Box sx={classes.container} ref={boxRef}>
        <Form />
      </Box>
    </>
  );
};

export default ApplyForm;
